<script>
export default {
  name: 'NoData',
  props: {
    dataType: {
      type: String,
      required: true
    },
    image: {
      type: String,
      required: false,
      default: null
    },
    link: {
      type: String,
      required: false
    }
  }
}
</script>

<template v-slot:no-data>
  <div class="create-first-wrapper">
    <v-alert :title="'There are no' + dataType + 's matching your selection.'">
      <p>There are no {{ dataType }}s. </p>
      <p v-if="link">Create your <router-link :to="link">first {{ dataType }}</router-link>.</p>
      <p v-if="dataType === 'event'">Sync new events or try a different value.</p>
    </v-alert>
    <img class="create-first-image" :src="require('@/assets/img/' + image)" />
  </div>
</template>

<style lang="scss" scoped>
.create-first-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.create-first-image {
  width: 300px;
}

p {
  display: inline-block;

  &:nth-child(2) {
    margin-left: 3px;
  }
}
</style>